import FeedbackModal from './components/feedback-modal-view';

export default FeedbackModal;
